<form class="modal-body login" role="form" (ngSubmit)="login()">
    <div class="alert alert-danger" *ngIf="authenticationError" jhiTranslate="login.messages.error.authentication">
        <strong>Failed to sign in!</strong> Please check your credentials and try again.
    </div>
    <button type="button" class="btn btn-default google">
        <i class="fa fa-google" aria-hidden="true"></i> <span
            jhiTranslate="login.form.google">Sign in with Google</span></button>

    <div class="has-feedback">
        <input type="text" class="form-control input-email" name="username" id="username"
               placeholder="{{'global.form.username.placeholder' | translate}}"
               [(ngModel)]="username">
        <i class="glyphicon glyphicon-envelope form-control-feedback"></i>
    </div>

    <div class="has-feedback">
        <input type="password" class="form-control" name="password" id="password"
               placeholder="{{'login.form.password.placeholder' | translate}}"
               [(ngModel)]="password">
        <i class="glyphicon glyphicon-lock form-control-feedback"></i>
    </div>
    <button type="submit" class="btn btn-zenika submit" jhiTranslate="login.form.button">Sign in</button>
</form>



// WEBPACK FOOTER //
// ./src/app/shared/login/login.component.html